import React from 'react'

interface ContactServiceProps {
  size?: 'small' | 'medium' | 'large'
  text?: string
  style?: React.CSSProperties
  url?: string
}

const ContactService: React.FC<ContactServiceProps> = ({
  size = 'medium',
  text = '联系客服',
  style = {},
  url = '',
}) => {
  const sizeConfig = {
    small: { fontSize: '12px', padding: '6px 12px', borderRadius: '12px' },
    medium: { fontSize: '14px', padding: '8px 16px', borderRadius: '16px' },
    large: { fontSize: '16px', padding: '12px 24px', borderRadius: '20px' },
  }

  const config = sizeConfig[size]

  // 如果没有提供URL，不渲染组件
  if (!url) {
    return null
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        e.stopPropagation() // 阻止事件冒泡
      }}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        background: 'linear-gradient(135deg, #07C160, #00AE42)',
        color: 'white',
        textDecoration: 'none',
        fontWeight: 600,
        boxShadow: '0 2px 8px rgba(7, 193, 96, 0.3)',
        transition: 'all 0.2s ease',
        ...config,
        ...style,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-1px)'
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(7, 193, 96, 0.4)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)'
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(7, 193, 96, 0.3)'
      }}
    >
      <span>💬</span>
      {text}
    </a>
  )
}

export default ContactService
